<ng-container *ngIf="vm">
  <div class="flex-fill d-flex flex-column movie-container">
    <div class="underlay-layer">
      <img
        osnSharedUseAsPicture
        [src]="vm.backgroundImageUrl"
        [imgQuery]="backgroundImgQuery"
        [param]="underlayImageParam"
        [alt]="vm.title"
      />
    </div>
    <div class="overlay-layer">
      <img osnSharedUseAsPicture [src]="vm.backgroundImageUrl" [imgQuery]="backgroundImgQuery" [alt]="title" />
    </div>

    <div class="vertical-gradient">
      <h1 class="spotlight-title d-flex mb-2 mb-sm-2 mb-lg-3">{{ vm.title }}</h1>
      <div class="description-container mb-4 mb-sm-3 mb-md-3">
        <p class="description">
          {{ vm.description }}
        </p>
      </div>
      <div>
        <button type="button" class="marketing-button large d-flex flex-column mb-4" (click)="onSignupClick(vm.buttonText)">
          {{ vm.buttonText }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
